import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import Lots from "../lots/Lots.module";
import Bids from "../bids/Bids.module";
import Bidders from "../bidders/Bidders.module";

MenuService.addMenuItem(new MenuItem('/auctions', i18n.t('Sales'), 3, 'server', [
  Lots.menuItem,
  Bidders.menuItem,
  Bids.menuItem,
], 'view_auction'));

const routes = [
  ...Lots.routes,
  ...Bidders.routes,
  ...Bids.routes,
]

export {routes}

